export enum Services {
    BACKEND = 'backend',
    DATAEXTENSIVEAPI = 'dataextensiveapi',
    MC_TAKE_EXAM = 'mc_take_exam',
    MC_REPORTING = 'mc_reporting',
}
